import React from 'react';
import * as EmptyState from '@modules/Dashboard/components/EmptyState/EmptyState';
export const ProductsEmptyState = () => {
    return (React.createElement(EmptyState.Root, { title: "No products found", subtitle: "Adjust your filters or try different search term." }));
};
